import ButtonTextSuggestions from './ButtonTextSuggestions';

export default ButtonTextSuggestions;
